import React from "react"
import s from "./Subheading.module.scss"

const Subheading = ({ children }) => (
    <p className={`${s.subHeading} ${s.justified}`}>{children}</p>
)

export default Subheading
